import { defineComponent } from 'vue';
import { PageVue } from '@/fairplayer/primary/page';
import { LoginFormVue } from '@/common/primary/auth/login-form';

export default defineComponent({
  name: 'LoginPage',

  components: { PageVue, LoginFormVue },
});
